import styled from 'styled-components';

type ListWrapperProps = {
  $show?: boolean;
};

export const ListWrapper = styled.ul<ListWrapperProps>`
  position: relative;
  margin: 0;
  margin-top: ${props => (props.$show ? 0 : '-400px')};
  z-index: 0;
  padding: 0;
  max-height: 400px;
  overflow-y: auto;
  cursor: pointer;
  background: #f4f7f9;
  transform-origin: top;
`;
